/**
 * 用户相关接口
 */
const PREFIX = "checkmall-user";
let userApi = {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    //获取手机验证码
    getpCaptcha: "/api/auth/sendCaptchaByPhone",
    //注册
    register: "/api/auth/user/register",
    //修改密码
    updatePwd: "/api/auth/user/recover",
    //用户信息
    userinfo: "/api/user/detail",
    //用户信息更新
    upuserinfo: "/api/dept/updateData",
    //用户投稿列表
    contributeList: "/api/user/contribute/mylist",
    // 新增用户投稿
    contributeAdd: "/api/user/contribute/addData",
    // 删除用户投稿
    contributeDel: "/api/user/contribute/deleteData",
    // 查看用户投稿
    contributeDetail: "/api/user/contribute/getDetail",
    userLogout: "/api/auth/user/logout",
  },
};
export default userApi;
